import { Ingredients } from '../../../../../pages/customize/components/Ingredients/Ingredients';
import Instructions from './components/Instructions';
import PairingImage from './components/PairingImage';
import Header from './components/Header';
import { Heading } from '@hungryroot/ramen';
import { getPairingDataImg } from '../../utils/utils';
import {
  getLikeDislikeRatingFromPairing,
  trackProductSaved,
  BinaryRatings,
} from '@hungryroot/ratings';
import {
  SaveRecipes,
  Variant as SaveVariant,
} from '../../../../../components/SaveRecipes/SaveRecipes';
import { trackSaveRecipe } from '../../../../../components/SaveRecipes/segment';
import styles from './OrderDetailsCard.module.css';
import { AuthGuard } from '../../../../../components/auth/AuthGuard/AuthGuard';

const OrderDetailsCard = ({
  customer,
  pairingData,
  openModal,
  openPDPModal,
  showRatings,
  orderId,
}) => {
  const dishTypeName = pairingData.dish_type ? pairingData.dish_type.name : '';

  //out of the box ingredients
  // make sure the variable is available on the page
  let OOBIngredients =
    window.outOfTheBox && window.outOfTheBox[dishTypeName]
      ? window.outOfTheBox[dishTypeName]
      : [];

  let openRDPModal = () => {
    if (!openModal) return;
    openModal();
  };

  let cardHeaderImage;
  let pairingImage = getPairingDataImg(pairingData);

  if (pairingImage && pairingData.is_featured) {
    cardHeaderImage = (
      <div
        className="pairing-image"
        style={{ backgroundImage: pairingImage }}
      ></div>
    );
  } else {
    cardHeaderImage = (
      <PairingImage
        ingredients={pairingData.ingredients}
        style="order-details"
      />
    );
  }
  return (
    <div className="order-details-card" onClick={openRDPModal}>
      <div className={styles['upper-card-wrapper']}>
        {cardHeaderImage}
        <AuthGuard
          authenticated={(auth) => {
            return (
              <SaveRecipes
                className={styles.save}
                variant={SaveVariant.Card}
                isFavorite={pairingData.is_favorited}
                pairingId={pairingData.id}
                testid={`myhungryroot-save-${pairingData.id}`}
                segment={{
                  path: 'delivered',
                  location: 'card',
                }}
                onFavoriteChange={(isFavorite) => {
                  if (customer === undefined || customer === null) return;
                  trackSaveRecipe({
                    pairingId: pairingData.id,
                    pairingName: pairingData.name,
                    category: 'pairings',
                    location: 'card',
                    path: 'delivered',
                    state: isFavorite,
                  });
                }}
                customer={auth.customerData}
              />
            );
          }}
        />
      </div>
      <Header pairingData={pairingData} hideIcon={true} />
      <div className="order-content hr-mb-24">
        <div className="ingredients-section">
          <Ingredients
            ingredients={pairingData.ingredients}
            onClick={openPDPModal}
          />
        </div>
        <div className="instructions-section">
          {pairingData.short_instruction_html && (
            <Instructions
              instructionsHtml={pairingData.short_instruction_html}
            />
          )}
        </div>
      </div>
      {OOBIngredients.length > 0 ? (
        <div className="add-ons">
          <span className="hr-subtitle-md-bold">Try adding these extras:</span>
          <span className="hr-subtitle-md">
            {OOBIngredients.map((ingredient, i) => {
              let name = ingredient.name;
              if (i < OOBIngredients.length - 1) {
                name += ', ';
              }
              return name;
            })}
          </span>
        </div>
      ) : null}

      {(window.showRatings || showRatings) && (
        <div className={styles['rate-recipe-wrapper']}>
          <Heading variant="H6">How did you like this recipe?</Heading>
          <BinaryRatings
            onRatingChange={(rating) => {
              if (customer === undefined || customer === null) {
                return;
              }

              trackProductSaved({
                likedDisliked: rating,
                location: 'card',
                path: 'delivered',
                category: 'pairings',
                pairingId: pairingData.id,
                pairingName: pairingData.name,
              });
            }}
            rating={getLikeDislikeRatingFromPairing(pairingData)}
            orderId={orderId}
            pairing={pairingData}
            testid={`pairing-${pairingData.id}-like-dislike`}
          />
        </div>
      )}
    </div>
  );
};

export default OrderDetailsCard;
